import * as angular from 'angular';
import StandardComponent from "components/standards/components/StandardComponent";
import SubmitButtonFieldController from "./controllers/submit-button.controller";

"use strict";

class SubmitButtonComponent extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/field/components/submitButtonField';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        action: '@',
        scanStation: '=',
        fc: '=',
        field: '=',
        row: '=',
        editScanStation: '@',
        data: '=',
        main: '='
    }

    // This will set what will be the controller of this component
    public controller : any = SubmitButtonFieldController;

    // This will set an alias
    public controllerAs: string = 'sbf';
}

angular.module('FieldModule').component('submitButtonField', <StandardComponent> new SubmitButtonComponent());